import React, { Component } from 'react';

import GoogleMap from './GoogleMap';

import { Form, Input, InputNumber, Button, Modal } from 'antd';
const FormItem = Form.Item;

class ParkinglocationForm extends Component {

  state = {
    modalVisible: false,
    defaultValues: null
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    if (nextProps.modalVisible !== this.state.modalVisible) {
      this.setState({
        modalVisible: nextProps.modalVisible
      });
    }

    if (nextProps.defaultValues !== this.state.defaultValues) {
      if (nextProps.defaultValues !== null) {
        nextProps.defaultValues.Definition
          ? nextProps.defaultValues.Definition.coordinates[0].slice(-1, 1)
          : null;
        this.props.form.setFieldsValue(nextProps.defaultValues)
      } else {
        this.props.form.resetFields();
      }
      this.setState({
        defaultValues: nextProps.defaultValues
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
        this.props.onModalCancel();
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const fullFormItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Kód" >
          {getFieldDecorator('Code', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Název" >
          {getFieldDecorator('Name', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Kapacita" >
          {getFieldDecorator('Capacity', {
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={0} max={9999999} />
          )}
        </FormItem>
        {/* {this.state.modalVisible */}
        <FormItem
          {...formItemLayout}
          label="Definice bod" >
          {getFieldDecorator('Point', {
            rules: [{
              type: 'object', message: 'Položka musí obsahovat objekt!',
            }, {
              required: true, message: 'Zadejte položku umístěním bodu do mapy!',
            }],
          })(
            <Input
              disabled={true} />
          )}
        </FormItem>
        <FormItem
          {...fullFormItemLayout}
          label="Definice zóny" >
          {getFieldDecorator('Definition', {
            rules: [{
              type: 'object', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            this.state.modalVisible ?
              <GoogleMap
                drawingManagerEnabled={this.state.defaultValues === null ? true : false}
                defaultPolygon={
                  this.state.defaultValues && this.state.defaultValues.Definition
                    ? this.state.defaultValues.Definition.coordinates[0]
                    : null
                }
                onPolygonChanged={(coordinates) => {
                  coordinates.push(coordinates[0]);
                  let definition = {
                    coordinates: [],
                    type: 'Polygon'
                  }
                  definition.coordinates.push(coordinates);
                  this.props.form.setFieldsValue({
                    Definition: definition
                  });
                }}
                onMarkerChanged={(coordinates) => {
                  let definition = {
                    coordinates: [],
                    type: 'Point'
                  }
                  definition.coordinates = coordinates;
                  this.props.form.setFieldsValue({
                    Point: definition
                  });
                }} />
              : <div></div>
          )}
        </FormItem>
        {/* : null} */}
        {this.state.defaultValues === null
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Vložit</Button>
          </FormItem>
          : null}
      </Form >
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={750}
          title={this.state.defaultValues === null ? "Vytvoření nové lokality" : "Detail lokality"}
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(ParkinglocationForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/ParkinglocationForm.js